/**
 * Created by tigran on 19.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const BuildingOutlineIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <polyline
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        points=" 23,11 23,4 9,4 9,15 "
        strokeLinejoin="miter"
      />
      <line
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={14}
        y1={31}
        x2={17.938}
        y2={31}
        strokeLinejoin="miter"
      />
      <line
        data-color="color-2"
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={16}
        y1={1}
        x2={16}
        y2={4}
        strokeLinejoin="miter"
      />
      <rect
        x={1}
        y={19}
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        width={13}
        height={12}
        strokeLinejoin="miter"
      />
      <line
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={6}
        y1={23}
        x2={9}
        y2={23}
        strokeLinejoin="miter"
      />
      <rect
        x={18}
        y={15}
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        width={13}
        height={16}
        strokeLinejoin="miter"
      />
      <line
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={23}
        y1={23}
        x2={26}
        y2={23}
        strokeLinejoin="miter"
      />
      <line
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={23}
        y1={19}
        x2={26}
        y2={19}
        strokeLinejoin="miter"
      />
      <line
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={6}
        y1={27}
        x2={9}
        y2={27}
        strokeLinejoin="miter"
      />
      <line
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={23}
        y1={27}
        x2={26}
        y2={27}
        strokeLinejoin="miter"
      />
    </svg>
  );
};
